import { ProductItemDecorator } from './ProductItemDecorator';
import { AppViewerOverrides } from '../types';
import { StoresApp as app } from './app';

export const StoresAppUI: AppViewerOverrides = {
  documentType: app.documentType,
  ItemDecoration: ProductItemDecorator,
  extraProps: ['onProductAddToCart'],
};
